// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-info {
  font-size: 0.7em;
  color: rgba(0, 0, 0, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/app/components/chat-list/chat-list.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,yBAAA;AACJ","sourcesContent":[".job-info {\n    font-size: .7em;\n    color: rgba(0, 0, 0, 0.5);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
